// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mz-0";